import Api from './api';

export const getBoards = async () => {
  return await Api.get('/kanban/boards');
};

export const paginateBoards = async (page = 1, size = 10, search = '') => {
  let url = `/kanban/boards/paginate?page=${page}&size=${size}`;
  if (search && search.trim().length > 0) url += `&search=${encodeURIComponent(search.trim())}`;
  return await Api.get(url);
};

export const getBoardById = async (id) => {
  return await Api.get(`/kanban/boards/${id}`);
};

export const createBoard = async (data) => {
  return await Api.post('/kanban/boards', data);
};

export const updateBoard = async (id, data) => {
  return await Api.put(`/kanban/boards/${id}`, data);
};

export const deleteBoard = async (id) => {
  return await Api.delete(`/kanban/boards/${id}`);
};

export const setDefaultBoard = async (id) => {
  return await Api.put(`/kanban/boards/${id}/set-default`);
};

export const getAvailableStatuses = async () => {
  return await Api.get('/kanban/statuses');
};

export const getFilterMetadata = async () => {
  return await Api.get('/kanban/filter-metadata');
};

export const moveCalledStatus = async (calledId, statusId, previousStatusId) => {
  return await Api.put(`/kanban/calleds/${calledId}/move-status`, { statusId, previousStatusId });
};

export const getCalledMoveFields = async (calledId) => {
  return await Api.get(`/kanban/calleds/${calledId}/move-fields`);
};

export const updateCalledFields = async (calledId, data) => {
  return await Api.put(`/kanban/calleds/${calledId}/fields`, data);
};

export const addKanbanAccompaniment = async (calledId, data) => {
  return await Api.post(`/kanban/calleds/${calledId}/accompaniments`, data);
};

export const validateRequiredCustomFields = async (calledId) => {
  return await Api.get(`/calleds/${calledId}/validate-required-fields`);
};
